import React from "react";
import {
  DashboardEmptyState,
  HubTableTemplate,
} from "../../components";

const items = [
  { id: "department", label: "Department" },
  { id: "tickets", label: "Tickets" },
  // { id: "completed", label: "Completed" },
  // { id: "scrapped", label: "Scrapped" },
];

const keys = [
  { value: "department", defaultValue: "—" },
  { value: "tickets", defaultValue: 0 },
  // { value: "completed", defaultValue: 0 },
  // { value: "scrapped", defaultValue: 0 },
];

export const RecentLaborTable = ({ rows = [], isLoading }) => {
  if (!isLoading && !rows.length) {
    return (
      <DashboardEmptyState
        icon="Clock"
        title="No recent labor"
        subtitle="Non-admin labor tickets will roll up here by department."
      />
    );
  }
  return (
    <HubTableTemplate
      id="dashboard-recent-labor"
      headerProps={{ items }}
      bodyProps={{ items: rows, keys }}
      isLoading={isLoading}
    />
  );
};

export default RecentLaborTable;
